import React from 'react';

import { coopDevToolsAvailable } from './coopDevToolsAvailable';

const CoopDevToolsPortal = coopDevToolsAvailable
    ? React.lazy(() => import('./CoopDevToolsPortal'))
    : () => null;

export default CoopDevToolsPortal;
